import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  FEEDBACK_LIST: {
    url: "terugkoppeling",
    method: "get",
  },
  UPDATE_FEEDBACK: {
    url: "terugkoppeling/update",
    method: "post",
  },
};

export const useFeedbackList = () =>
  useApiFetcherSWR(API_ENDPOINT.FEEDBACK_LIST);

export const useUpdateFeedback = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_FEEDBACK);